module.exports = __webpack_public_path__ + "img/Delete.fb4fa89d.svg";